import { DecimalPipe } from '@angular/common';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { DEFAULT_NUMBER_FORMAT } from '../consts';

@Pipe({ name: 'rbrNumber' })
export class NumberPipe implements PipeTransform {
    private readonly decimalPipe = inject(DecimalPipe);

    transform(value: number | null | undefined, format = DEFAULT_NUMBER_FORMAT): string | null {
        if (value === null || value === undefined) {
            return null;
        }

        return this.decimalPipe.transform(value, format);
    }
}
